module.exports = __webpack_public_path__ + "img/flags/GF.f9cd69e.png";